<template>
  <div class="mt-5 bg-white border-white p-5 sm:p-10 border-2 rounded-[40px]">
    <div
      class="flex gap-4 bg-grey-agro px-2 py-2 sm:px-4 sm:py-4 rounded-full whitespace-nowrap w-full overflow-x-scroll hidden-scroll"
    >
      <v-btn
        class="rounded-full"
        :class="item.id === props.selected?.id && 'text-primary-agro'"
        v-for="(item, key) in props.data"
        :key="key"
        @click="onChangeSelected(item)"
      >
        {{ item.attributes.title }}
      </v-btn>
    </div>
    <DetailSustainbility :data="props.selected" />
  </div>
</template>

<!-- eslint-disable no-undef -->
<script setup>
import DetailSustainbility from "@/components/Sustainbility/DetailSustainbility.vue";

const emits = defineEmits(["update:modelValue", "handleArticle"]);
const props = defineProps(["data", "selected"]);

const onChangeSelected = (data) => {
  emits("update:modelValue", data);
  emits("handleArticle", data.attributes.category);
};
</script>